import axios from "axios";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";

function EditMedical({ profileInit, isOpen, setIsOpen, onUpdateSuccess }) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: profileInit.id,
    mcRefNo: profileInit?.Health?.mcRefNo || '',
    mcApprovalDate: profileInit?.Health?.mcApprovalDate ? profileInit.Health.mcApprovalDate.slice(0, 10) : '',
    mcValidUntil: profileInit?.Health?.mcValidUntil ? profileInit.Health.mcValidUntil.slice(0, 10) : '',
    mcStatus: profileInit?.Health?.mcStatus || '',
    mcWith: profileInit?.Health?.mcWith || '',
  });

  useEffect(() => {
    setFormData({
      id: profileInit.id,
      mcRefNo: profileInit?.Health?.mcRefNo || '',
      mcApprovalDate: profileInit?.Health?.mcApprovalDate ? profileInit.Health.mcApprovalDate.slice(0, 10) : '',
      mcValidUntil: profileInit?.Health?.mcValidUntil ? profileInit.Health.mcValidUntil.slice(0, 10) : '',
      mcStatus: profileInit?.Health?.mcStatus || '',
      mcWith: profileInit?.Health?.mcWith || '',
    });
  }, [profileInit]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const updateMedical = async () => {
    setLoading(true);
    try {
      const result = await axios.put(
        `${apiUrl}/employee/updatePersonalInfo`,
        { id: formData.id, ...formData },
        { headers: { loginToken: localStorage.getItem("loginToken") } }
      );
      if (result.data.message || result.status === 200) {
        swal({ icon: "success", title: "Updated", text: "Medical info updated!", buttons: false, timer: 2000 });
        setIsOpen(false);
        if (onUpdateSuccess) await onUpdateSuccess();
      }
    } catch (err) {
      swal({ title: "Error", icon: "error", text: err.response?.data?.error || "Update failed" });
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="text-black">
      <div className="fixed inset-0 bg-gray-500 opacity-75 z-50" onClick={() => setIsOpen(false)} />
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden w-full max-w-lg mx-4">
          <div className="p-6 relative">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">Update Medical Information</h2>
            <hr className="mb-6 border-gray-300" />

            <form className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MC Reference No</label>
                <input name="mcRefNo" type="text" value={formData.mcRefNo} onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MC Status</label>
                <select name="mcStatus" value={formData.mcStatus} onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Select MC Status</option>
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                  <option value="N/A">N/A</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MC Approval Date</label>
                <input name="mcApprovalDate" type="date" value={formData.mcApprovalDate} onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MC Valid Until</label>
                <input name="mcValidUntil" type="date" value={formData.mcValidUntil} onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">MC With</label>
                <select name="mcWith" value={formData.mcWith} onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Select MC With</option>
                  <option value="By Company">By Company</option>
                  <option value="Himself">Himself</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <button type="button" onClick={updateMedical} disabled={loading}
                  className="w-full mt-2 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition duration-150 flex items-center justify-center">
                  {loading ? "Saving..." : "Save Medical Info"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditMedical;
